import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Menu, X } from 'lucide-react';
import AdminDropdown from './AdminDropdown';
import UserProfileDropdown from './UserProfileDropdown'; // NOVO IMPORT

function Navbar() {
    const { isAuthenticated, participanteRole } = useAuth();
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const getLinkClass = (path) => {
        const isActive = location.pathname === path || (path === '/eventos' && location.pathname.startsWith('/eventos/') && location.pathname !== '/eventos');
        
        // Estilo base
        let classes = "text-sm font-medium transition-colors";
        
        // Estilo de link ativo
        if (isActive) {
            classes += " text-primary font-semibold border-b-2 border-primary pb-1";
        } else {
            classes += " text-muted-foreground hover:text-primary";
        }
        
        return classes;
    };

    const getMobileLinkClass = (path) => {
        const isActive = location.pathname === path || (path === '/eventos' && location.pathname.startsWith('/eventos/') && location.pathname !== '/eventos');
        
        // Estilo base móvel
        let classes = "block py-2 px-4 text-sm rounded-md transition-colors";
        
        // Estilo de link ativo móvel
        if (isActive) {
            classes += " bg-primary text-primary-foreground font-semibold hover:bg-primary/90";
        } else {
            classes += " text-muted-foreground hover:bg-accent hover:text-primary";
        }
        
        return classes;
    };

    return (
        <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
            <div className="container flex h-14 items-center justify-between">
                {/* Left side: Mobile Menu Button (on mobile) and Logo/Text */}
                <div className="flex items-center">
                    {/* Mobile Menu Button - visible only on small screens */}
                    <button 
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
                        className="mr-2 p-2 rounded-md hover:bg-accent md:hidden transition-colors"
                        aria-label={isMobileMenuOpen ? "Fechar menu principal" : "Abrir menu principal"}
                        aria-expanded={isMobileMenuOpen}
                    >
                        {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                    {/* Logo/Text */}
                    <Link to="/dashboard" className="flex items-center space-x-2">
                        {/* Desktop: Show text "Gestão de Presenças" */}
                        <span className="font-bold hidden md:block text-lg">Gestão de Presenças</span>
                        {/* Mobile: Show pa-logo.png */}
                        <img src="/ucm-logo.png" alt="Gestão de Presenças Logo" className="h-8 w-auto md:hidden" />
                    </Link>
                </div>

                {/* Right side: Desktop Nav (on desktop) and Auth/Profile links */}
                <div className="flex items-center">
                    {/* Desktop Navigation Links - hidden on small screens */}
                    <nav className="hidden md:flex items-center space-x-6 text-sm font-medium mr-4 h-full">
                        {isAuthenticated && (
                            <>
                                <Link to="/eventos" className={getLinkClass('/eventos')}>Eventos</Link>
                                {participanteRole !== 'ROLE_ADMIN' && (
                                    <Link to="/meu-checkin" className={getLinkClass('/meu-checkin')}>Meu Check-in</Link>
                                )}
                                {participanteRole === 'ROLE_ADMIN' && (
                                    <AdminDropdown />
                                )}
                            </>
                        )}
                    </nav>
                    {/* Auth/Profile links - always visible, but styled for desktop */}
                    <nav className="flex items-center">
                        {!isAuthenticated ? (
                            <>
                                <Link to="/login" className={`${getLinkClass('/login')} hidden sm:block`}>Login</Link>
                                <Link to="/register" className={`${getLinkClass('/register')} ml-4 hidden sm:block`}>Registrar</Link>
                            </>
                        ) : (
                            <UserProfileDropdown /> // NOVO COMPONENTE
                        )}
                    </nav>
                </div>
            </div>

            {/* Mobile Menu Dropdown - visible only when open on small screens */}
            {isMobileMenuOpen && (
                <div className="md:hidden border-t">
                    <nav className="flex flex-col px-2 pt-2 pb-4 space-y-1">
                        {isAuthenticated && (
                            <>
                                <Link to="/eventos" onClick={() => setIsMobileMenuOpen(false)} className={getMobileLinkClass('/eventos')}>Eventos</Link>
                                {participanteRole !== 'ROLE_ADMIN' && (
                                    <>
                                        <Link to="/meus-certificados" onClick={() => setIsMobileMenuOpen(false)} className={getMobileLinkClass('/meus-certificados')}>Meus Certificados</Link>
                                        <Link to="/meu-checkin" onClick={() => setIsMobileMenuOpen(false)} className={getMobileLinkClass('/meu-checkin')}>Meu Check-in</Link>
                                    </>
                                )}
                                <Link to="/profile" onClick={() => setIsMobileMenuOpen(false)} className={getMobileLinkClass('/profile')}>Meu Perfil</Link>
                                {participanteRole === 'ROLE_ADMIN' && (
                                    <>
                                        <h3 className="px-4 pt-2 text-xs font-semibold text-muted-foreground uppercase tracking-wider">Admin</h3>
                                        <Link to="/admin/eventos" onClick={() => setIsMobileMenuOpen(false)} className={getMobileLinkClass('/admin/eventos')}>Gerenciar Eventos</Link>
                                        <Link to="/admin/checkin" onClick={() => setIsMobileMenuOpen(false)} className={getMobileLinkClass('/admin/checkin')}>Check-in</Link>
                                        <Link to="/admin/inscricoes" onClick={() => setIsMobileMenuOpen(false)} className={getMobileLinkClass('/admin/inscricoes')}>Gerenciar Inscrições</Link>
                                        <Link to="/admin/usuarios" onClick={() => setIsMobileMenuOpen(false)} className={getMobileLinkClass('/admin/usuarios')}>Gerenciar Usuários</Link>
                                    </>
                                )}
                            </>
                        )}
                        {!isAuthenticated && (
                            <div className="sm:hidden">
                                <Link to="/login" onClick={() => setIsMobileMenuOpen(false)} className={getMobileLinkClass('/login')}>Login</Link>
                                <Link to="/register" onClick={() => setIsMobileMenuOpen(false)} className={getMobileLinkClass('/register')}>Registrar</Link>
                            </div>
                        )}
                    </nav>
                </div>
            )}
        </header>
    );
}

export default Navbar;
